import { Component, OnInit } from '@angular/core';
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { Observable, Subject } from 'rxjs/index';
import { GatewayActions } from '../../../../../../core/state/gateway.actions';
import { GatewaySelectors } from '../../../../../../core/state/gateway.selectors';

@Component({
    selector: 'two-way-devices-shared-number',
    templateUrl: './devices-shared-number.component.html',
    styleUrls: ['./devices-shared-number.component.css']
})

export class DevicesSharedNumberComponent implements OnInit {
    static modalOptions: ModalOptions = {
        initialState: {
            okLabel: 'Save',
            cancelLabel: 'Close'
        },
        backdrop: 'static',
        class: 'modal-lg'
    };

    public sharedNumbers: Array<any>;
    public selectedNumber$: Subject<number> = new Subject();
    public sharedNumbers$: Observable<any>;

    constructor(
        public bsModalRef: BsModalRef,
        private gatewayActions: GatewayActions,
        private selectors: GatewaySelectors
    ) {
        this.sharedNumbers$ = this.selectors.selectSharedNumber();
    }

    public onCancel(): void {
        this.bsModalRef.hide();
    }

    ngOnInit(): void {
        // this.selectedNumber$ = new Subject();
        this.gatewayActions.getSharedNumbers(0);
    }

    selectSharedNumber(sharedNumber): void {
        this.selectedNumber$.next(sharedNumber.phoneNumber);
        this.onCancel();
    }
}
